import React from "react";
import { CSwitch } from "@coreui/react";
import CIcon from "@coreui/icons-react";

import * as Status from "constants/statusBooking";

function Item({ onEditItem, state, id, check }) {
  return state === Status.COMPLETED ? (
    <CIcon name="cil-check" size="xl" />
  ) : state === Status.CANCELED ? (
    <CIcon name="cil-x" size="xl" />
  ) : (
    <CSwitch
      className={"mx-1"}
      shape={"pill"}
      color={check ? "success" : "danger"}
      checked={state === Status.PENDING}
      onChange={(e) => onEditItem(id, e.target.checked)}
    />
  );
}

export default Item;
